import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatRangeString, getRecibosPagos, recibosPagosTableData } from "./handlers";
import { Table } from "../../components";
import { renderModal } from "../handlers";
import Recibo from "./Recibo";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PulseOpacitySpinner from "../../components/MuniSpinner/PulseOpacitySpinner";
import HelperText from "../../components/HelperText";
import { UserContext } from "../../context/UserWrapper";

const Recibos = () => {
  const { actions: ua } = useContext(UserContext);
  const [recibosPagos, setRecibosPagos] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [montoTotal, setMontoTotal] = useState("");
  const [modalIsOpenn, setModalIsOpenn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fecha_ini: "",
      fecha_fin: "",
    },
  });

  useEffect(() => {
    let submittedData = {
      fecha_ini: "",
      fecha_fin: "",
    };
    getRecibosPagos(submittedData, setRecibosPagos, setMontoTotal, setError, setIsLoading);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className='d-flex gap-4 align-items-center mb-4'>
        <h3 className='mb-0'>Recibos Pagos</h3>
        <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: "38px" }}>
          <span>Volver</span>
        </Link>
      </div>
      <Form className='mb-2' onSubmit={handleSubmit((data) => getRecibosPagos(data, setRecibosPagos, setMontoTotal, setError, setIsLoading))}>
        <fieldset className='d-flex gap-4 align-items-end'>
          <div className='relative'>
            <label className='mb-2'>Fecha de inicio</label>
            <input className='form-control' type='date' {...register("fecha_ini")} defaultValue={new Date()} />
            <p className='absolute bottom-0 text-danger' style={{ fontSize: "15px", marginBottom: "0px" }}>
              {errors?.fecha_ini?.message}
            </p>
          </div>
          <div>
            <label className='mb-2'>Fecha fin</label>
            <input className='form-control' type='date' {...register("fecha_fin")} />
          </div>
          <Button type='submit'>Consultar</Button>
        </fieldset>
      </Form>
      <div>
        <HelperText className='mb-0'>Seleccione un rango de fechas para buscar recibos pagos.</HelperText>
        <HelperText className='mb-0'>Si no se selecciona ninguna fecha, se mostraran los recibos de los últimos 30 días.</HelperText>
        <HelperText className='mb-0'>Si se seleccionan fechas iguales, se mostraran todos los recibos pagos.</HelperText>
        <HelperText className='mb-0'>Si se selecciona únicamente "Fecha de inicio", se tendrán en cuenta los 30 días posteriores a la misma, incluida.</HelperText>
        <HelperText className='mb-0'>Si se selecciona únicamente "Fecha fin", se tendrán en cuenta los 30 dias previos a la misma.</HelperText>
      </div>
      <hr />
      {isLoading ? (
        <PulseOpacitySpinner />
      ) : (
        recibosPagos &&
        montoTotal !== "" && (
          <div>
            {ua.hasRole("sudo") && (
              <h5>
                Monto total {formatRangeString(getValues("fecha_ini"), getValues("fecha_fin"))}: ${montoTotal}
              </h5>
            )}
            <h6>
              Total de recibos pagos {formatRangeString(getValues("fecha_ini"), getValues("fecha_fin"))}: {recibosPagos.length}
            </h6>
            <Table data={recibosPagosTableData(recibosPagos, setSelectedRow, setRecibosPagos, setModalIsOpenn, ua)} name='actas' />
            {selectedRow && modalIsOpenn && renderModal(modalIsOpenn, setModalIsOpenn, `Recibo ${selectedRow?.numero_recibo}`, <Recibo recibo={selectedRow} setRecibosPagos={setRecibosPagos} />, "lg")}
          </div>
        )
      )}
    </div>
  );
};

export default Recibos;
